import React from "react";
import { CircleLoader } from "react-awesome-loaders";
import "./loader.css";

function Loader() {
  return (
    <div>
      <section className="loader">
        <>
          <CircleLoader
            meshColor={"#6366F1"}
            lightColor={"#E0E7FF"}
            duration={1.5}
            desktopSize={"90px"}
            mobileSize={"64px"}
          />
        </>
      </section>
    </div>
  );
}

export default Loader;
